/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GoogleAnalyticsMeasurementQualityData } from './GoogleAnalyticsMeasurementQualityData';
import {
    GoogleAnalyticsMeasurementQualityDataFromJSON,
    GoogleAnalyticsMeasurementQualityDataFromJSONTyped,
    GoogleAnalyticsMeasurementQualityDataToJSON,
    GoogleAnalyticsMeasurementQualityDataToJSONTyped,
} from './GoogleAnalyticsMeasurementQualityData';
import type { TrackingQualityDailyData } from './TrackingQualityDailyData';
import {
    TrackingQualityDailyDataFromJSON,
    TrackingQualityDailyDataFromJSONTyped,
    TrackingQualityDailyDataToJSON,
    TrackingQualityDailyDataToJSONTyped,
} from './TrackingQualityDailyData';
import type { TrackingQualityEventTypeData } from './TrackingQualityEventTypeData';
import {
    TrackingQualityEventTypeDataFromJSON,
    TrackingQualityEventTypeDataFromJSONTyped,
    TrackingQualityEventTypeDataToJSON,
    TrackingQualityEventTypeDataToJSONTyped,
} from './TrackingQualityEventTypeData';
import type { TrackingQualityDomainData } from './TrackingQualityDomainData';
import {
    TrackingQualityDomainDataFromJSON,
    TrackingQualityDomainDataFromJSONTyped,
    TrackingQualityDomainDataToJSON,
    TrackingQualityDomainDataToJSONTyped,
} from './TrackingQualityDomainData';

/**
 * 
 * @export
 * @interface TrackingQualityData
 */
export interface TrackingQualityData {
    /**
     * 
     * @type {number}
     * @memberof TrackingQualityData
     */
    totalEvents?: number;
    /**
     * 
     * @type {number}
     * @memberof TrackingQualityData
     */
    uniqueVisitors?: number;
    /**
     * 
     * @type {number}
     * @memberof TrackingQualityData
     */
    uniqueOrderingVisitors?: number;
    /**
     * 
     * @type {number}
     * @memberof TrackingQualityData
     */
    entryEvents?: number;
    /**
     * 
     * @type {number}
     * @memberof TrackingQualityData
     */
    updateEvents?: number;
    /**
     * 
     * @type {number}
     * @memberof TrackingQualityData
     */
    orderEvents?: number;
    /**
     * 
     * @type {number}
     * @memberof TrackingQualityData
     */
    pairedOrderEvents?: number;
    /**
     * 
     * @type {number}
     * @memberof TrackingQualityData
     */
    unpairedOrderEvents?: number;
    /**
     * 
     * @type {number}
     * @memberof TrackingQualityData
     */
    orderEventsWithoutOrderNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof TrackingQualityData
     */
    erpOrders?: number;
    /**
     * 
     * @type {number}
     * @memberof TrackingQualityData
     */
    erpOrdersWithPageOrderEvent?: number;
    /**
     * 
     * @type {Array<TrackingQualityEventTypeData>}
     * @memberof TrackingQualityData
     */
    eventTypes?: Array<TrackingQualityEventTypeData>;
    /**
     * 
     * @type {Array<TrackingQualityDailyData>}
     * @memberof TrackingQualityData
     */
    daily?: Array<TrackingQualityDailyData>;
    /**
     * 
     * @type {Array<TrackingQualityDomainData>}
     * @memberof TrackingQualityData
     */
    domains?: Array<TrackingQualityDomainData>;
    /**
     * 
     * @type {Array<GoogleAnalyticsMeasurementQualityData>}
     * @memberof TrackingQualityData
     */
    googleAnalytics?: Array<GoogleAnalyticsMeasurementQualityData>;
}

/**
 * Check if a given object implements the TrackingQualityData interface.
 */
export function instanceOfTrackingQualityData(value: object): value is TrackingQualityData {
    return true;
}

export function TrackingQualityDataFromJSON(json: any): TrackingQualityData {
    return TrackingQualityDataFromJSONTyped(json, false);
}

export function TrackingQualityDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackingQualityData {
    if (json == null) {
        return json;
    }
    return {
        
        'totalEvents': json['totalEvents'] == null ? undefined : json['totalEvents'],
        'uniqueVisitors': json['uniqueVisitors'] == null ? undefined : json['uniqueVisitors'],
        'uniqueOrderingVisitors': json['uniqueOrderingVisitors'] == null ? undefined : json['uniqueOrderingVisitors'],
        'entryEvents': json['entryEvents'] == null ? undefined : json['entryEvents'],
        'updateEvents': json['updateEvents'] == null ? undefined : json['updateEvents'],
        'orderEvents': json['orderEvents'] == null ? undefined : json['orderEvents'],
        'pairedOrderEvents': json['pairedOrderEvents'] == null ? undefined : json['pairedOrderEvents'],
        'unpairedOrderEvents': json['unpairedOrderEvents'] == null ? undefined : json['unpairedOrderEvents'],
        'orderEventsWithoutOrderNumber': json['orderEventsWithoutOrderNumber'] == null ? undefined : json['orderEventsWithoutOrderNumber'],
        'erpOrders': json['erpOrders'] == null ? undefined : json['erpOrders'],
        'erpOrdersWithPageOrderEvent': json['erpOrdersWithPageOrderEvent'] == null ? undefined : json['erpOrdersWithPageOrderEvent'],
        'eventTypes': json['eventTypes'] == null ? undefined : ((json['eventTypes'] as Array<any>).map(TrackingQualityEventTypeDataFromJSON)),
        'daily': json['daily'] == null ? undefined : ((json['daily'] as Array<any>).map(TrackingQualityDailyDataFromJSON)),
        'domains': json['domains'] == null ? undefined : ((json['domains'] as Array<any>).map(TrackingQualityDomainDataFromJSON)),
        'googleAnalytics': json['googleAnalytics'] == null ? undefined : ((json['googleAnalytics'] as Array<any>).map(GoogleAnalyticsMeasurementQualityDataFromJSON)),
    };
}

export function TrackingQualityDataToJSON(json: any): TrackingQualityData {
    return TrackingQualityDataToJSONTyped(json, false);
}

export function TrackingQualityDataToJSONTyped(value?: TrackingQualityData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalEvents': value['totalEvents'],
        'uniqueVisitors': value['uniqueVisitors'],
        'uniqueOrderingVisitors': value['uniqueOrderingVisitors'],
        'entryEvents': value['entryEvents'],
        'updateEvents': value['updateEvents'],
        'orderEvents': value['orderEvents'],
        'pairedOrderEvents': value['pairedOrderEvents'],
        'unpairedOrderEvents': value['unpairedOrderEvents'],
        'orderEventsWithoutOrderNumber': value['orderEventsWithoutOrderNumber'],
        'erpOrders': value['erpOrders'],
        'erpOrdersWithPageOrderEvent': value['erpOrdersWithPageOrderEvent'],
        'eventTypes': value['eventTypes'] == null ? undefined : ((value['eventTypes'] as Array<any>).map(TrackingQualityEventTypeDataToJSON)),
        'daily': value['daily'] == null ? undefined : ((value['daily'] as Array<any>).map(TrackingQualityDailyDataToJSON)),
        'domains': value['domains'] == null ? undefined : ((value['domains'] as Array<any>).map(TrackingQualityDomainDataToJSON)),
        'googleAnalytics': value['googleAnalytics'] == null ? undefined : ((value['googleAnalytics'] as Array<any>).map(GoogleAnalyticsMeasurementQualityDataToJSON)),
    };
}

